import { render, staticRenderFns } from "./DownIndex.vue?vue&type=template&id=b6c22610&scoped=true"
import script from "./DownIndex.vue?vue&type=script&lang=js"
export * from "./DownIndex.vue?vue&type=script&lang=js"
import style0 from "./DownIndex.vue?vue&type=style&index=0&id=b6c22610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c22610",
  null
  
)

export default component.exports